import { ModalFooter, ModalBody, ModalHeader, Modal, Button } from 'reactstrap';

function FinalizeConfirmModal({ isOpen, toggle, onYes }) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalClassName="custom-modal-size"
      centered
    >
      <ModalHeader toggle={toggle}>Confirmation</ModalHeader>
      <ModalBody>Are you sure you want to move to finalise it?</ModalBody>
      <ModalFooter className="modalFooter">
        <Button className="item custom-light-btn" onClick={toggle}>
          No
        </Button>
        <Button className="item custom-btn" onClick={onYes}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default FinalizeConfirmModal;
